import comp from "./PageNotFound";
export default comp;
